(function () {
  /**
   * @awaitingdeprecation
   */
  angular.module('binky.core.organizations.system-group').constant('SYSTEM_GROUP', {
    CACHE_ID: 'SystemGroupCacheId',
    EVERYBODY: '_everybody',
  });
})();
